var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "url-content" }, [
    _vm.linkType === "simple"
      ? _c(
          "blockquote",
          { staticClass: "url-content__container", attrs: { cite: _vm.url } },
          [
            _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
              _c("div", { staticClass: "url-content__body" }, [
                _c("h4", { staticClass: "url-content__title" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "url-content__description" }, [
                  _vm._v(_vm._s(_vm.description))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "url-content__domain" }, [
                  _vm._v(_vm._s(_vm.domain))
                ])
              ])
            ])
          ]
        )
      : _vm.linkType === "rich"
        ? _c(
            "blockquote",
            { staticClass: "url-content__container", attrs: { cite: _vm.url } },
            [
              _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
                _c("div", { staticClass: "url-content__thumbnail" }, [
                  _c("div", { staticClass: "url-content__image-container" }, [
                    _vm.thumbnailUrl
                      ? _c("img", {
                          style:
                            "background-image: url(" + _vm.thumbnailUrl + ")",
                          attrs: {
                            alt: _vm.title,
                            src:
                              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="
                          }
                        })
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "url-content__body" }, [
                  _c("h4", { staticClass: "url-content__title" }, [
                    _vm._v(_vm._s(_vm.title))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "url-content__description" }, [
                    _vm._v(_vm._s(_vm.description))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "url-content__domain" }, [
                    _vm._v(_vm._s(_vm.domain))
                  ])
                ])
              ])
            ]
          )
        : _vm.linkType === "embed"
          ? _c(
              "blockquote",
              {
                staticClass:
                  "url-content__container url-content__container--embed",
                attrs: { cite: _vm.url }
              },
              [_c("div", { domProps: { innerHTML: _vm._s(_vm.html) } })]
            )
          : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }